export default {
  contact_provider: 'Vă rugăm să contactați furnizorul pentru a activa această opțiune.',
};
